var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNcSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16342 32 0 24.8366 0 16C0 7.16342 7.16342 0 16 0C24.8366 0 32 7.16342 32 16ZM14.1493 24.4719L26.0203 12.6009C26.4234 12.1978 26.4234 11.5442 26.0203 11.1411L24.5605 9.6813C24.1574 9.27814 23.5037 9.27814 23.1006 9.6813L13.4194 19.3625L8.89942 14.8425C8.49633 14.4394 7.84271 14.4394 7.43955 14.8425L5.97975 16.3023C5.57665 16.7054 5.57665 17.359 5.97975 17.7621L12.6894 24.4718C13.0926 24.875 13.7461 24.875 14.1493 24.4719Z",
    fill: "#54B91B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcSuccess);
export default __webpack_public_path__ + "static/media/NcSuccess.931fa1381febc5db6dbee6f94e50dd51.svg";
export { ForwardRef as ReactComponent };